<template>
  <v-navigation-drawer
    v-model="showDrawer"
    app
    :right="right"
    :width="300"
    class="navigation"
  >
    <v-card class="d-flex flex-column h-100" flat color="#00000000" :disabled="disableSideMenu">
      <v-card class="ma-2 pa-3" rounded="xl" color="primary">
        <div class="d-flex">
          <v-spacer></v-spacer>
          <span
            id="themeswitchericon"
            class="icon-secondary pointer"
            @click="toggleThemeSwitcher"
          >
            <v-icon>mdi-weather-night</v-icon>
          </span>
        </div>

        <div class="text-secondary webkart-navigation">
          {{ $t("app-name") }}
        </div>
        <div
          v-if="personelName"
          class="text-secondary-hint"
          style="font-size: 0.875rem"
        >
          {{ personelName }}
        </div>
      </v-card>

      <v-list class="py-0" link dense>
        <template v-for="(navItem, index) in navigationItems">
          <navigation-list-group
            v-if="isGroupItem(navItem)"
            :key="index"
            :item="navItem"
          ></navigation-list-group>
          <navigation-list-item
            v-else
            :key="index"
            :text="navItem.title"
            :icon="navItem.icon"
            :to="navItem.to"
            @click="click"
          ></navigation-list-item>
        </template>
        <!-- <NavigationListItem
        :text="'nav-exit'"
        :icon="'mdi-exit-to-app'"
        :to="''"
        @click="click"
      ></NavigationListItem> -->
      </v-list>
      
      <div class="mt-auto">
        <!-- <div v-if="logoutPermission" class="mx-2"> -->
        <div  class="mx-2">
          <v-btn block color="primary" @click="click('nav-logout')">
            {{ $t("nav-logout") }}
          </v-btn>
        </div>
        <div class="d-flex ma-2">
          <v-spacer></v-spacer>
          <small class="">{{ $t("version") }} : {{ $appVersion }}</small>
        </div>
      </div>
      
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import NavigationListItem from "./NavigationListItem.vue";
import NavigationListGroup from "./NavigationListGroup.vue";
//import LocaleSwitcher from "../widget/LocaleSwitcher.vue";
import Navigation from "./Navigation";
import AdminNavigation from "./AdminNavigation";
import EosUtils from "../../utils/EosUtils";

export default {
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NavigationListItem,
    NavigationListGroup,
    //LocaleSwitcher
  },
  data() {
    return {
      showDrawer: this.drawer,
      navigationItems: [],
      numberList: [],
      right: this.$vuetify.rtl,
      personelName: "",
      logoutPermission:true,
    };
  },
  computed: {
    disableSideMenu(){
      return this.$store.state.settings.disableSideMenu
    }
  },
  mounted() {
  
    this.setThemeIcon();
    this.getPersonelName();
    var domainLoginName = localStorage.getItem("domainLoginName");
    if(domainLoginName){
      this.logoutPermission=false;
    }
    ////debugger;
              
  },
  created() {
    //window.addEventListener('beforeunload', this.createDrawerItems)
    //window.beforeunload = this.createDrawerItems();
    this.createDrawerItems();
  },
  methods: {
    getPersonelName() {
      ////debugger;
      var colorNumber;
      var result=localStorage.getItem('manage');
      const retrievedObject =  JSON.parse(result);
      if(retrievedObject){
        if(retrievedObject.Perno){
        this.personelName = retrievedObject.PersonName + "( " + retrievedObject.Perno + " )";
        colorNumber=retrievedObject.Them;
      }
      }
      else{
        localStorage.removeItem('manage');
        let personel = this.$store.state.personel.personelDetail;
      if (personel.Perno) {
        this.personelName = personel.PersonName + "( " + personel.Perno + " )";
      }
      colorNumber=personel.Them;

      }


      
    //  var colorNumber= personel.Them;
     if (EosUtils.isWebKartAdmin()) {
      colorNumber=localStorage.getItem("colorAdminNum");
      ////debugger
     }
     var newItem=localStorage.getItem('newItem');
     if(newItem){
      colorNumber=newItem;
     }

     colorNumber=colorNumber.replace(/\s+/g, '');
     this.setUserTheme(colorNumber);
    //  localStorage.removeItem('manage');
    },
    click(text) {
      if (text === "nav-logout") {
        this.$emit("logout");
      }
    },
    toggleThemeSwitcher() {
      this.toggleTheme();
      this.setThemeIcon();
    },
    setThemeIcon() {
      ////console.log("this.isDarkTheme:"+this.isDarkTheme());
      if (this.isDarkTheme() === true) {
        document.getElementById("themeswitchericon").innerHTML =
          '<i data-v-0893c166="" aria-hidden="true" class="v-icon notranslate mdi mdi-weather-night theme--light icon-secondary"></i>'; //"🌙";
      } else {
        document.getElementById("themeswitchericon").innerHTML =
          '<i data-v-0893c166="" aria-hidden="true" class="v-icon notranslate mdi mdi-white-balance-sunny theme--light icon-secondary"></i>'; //"☀️";
      }
    },
    isGroupItem(navItem) {
      return navItem.subItems && navItem.subItems.length > 0;
    },
    toggleDrawer() {
      this.showDrawer = !this.showDrawer;
    },
    setNavigationArray(arr) {
      this.numberList = arr || [];
      this.createDrawerItems();
      this.setThemeIcon();
    },
    getOrCreateMainNavItem(id, icon) {
      var navItem = this.navigationItems.find((item) => item.id === id);
      if (navItem == null) {
        navItem = {
          id: id,
          title: id,
          icon: icon,
          to: "",
          subItems: [],
        };
        this.navigationItems.push(navItem);
      }
      return navItem;
    },
    addSubItem(item, childId, childIcon, to = "", subItems = []) {
      var child = {
        id: childId,
        title: childId,
        icon: childIcon,
        to: to,
        subItems: subItems,
      };
      item.subItems.push(child);
    },
    createDrawerItems() {
      //console.log('createDrawerItems');
      if (EosUtils.isWebKartAdmin()) {
        var list = AdminNavigation.getNavigationList();
        console.log("createDrawerItems", list);
        this.navigationItems = list;
      } else {
        //var numberList = [1, 2, 3, 4, 6, 7, 9, 15, 17, 24];
        this.navigationItems = Navigation.getNavigationList(this.numberList);

      }
    },
  },
  watch: {
    "$vuetify.rtl"() {
      this.right = this.$vuetify.rtl;
    },
  },
};
</script>

<style scoped>
.v-list-item {
  flex: 0;
}

.footer {
  position: fixed;
  bottom: 0;
  justify-content: center;
  width: 100%;
}

.webkart-navigation {
  font-size: 2rem;
  padding-top: 1rem;
}

.navigation {
  height: calc(100% - 30px) !important;
  background-color: var(--background-drawer) !important;
}
.mdi-lock-reset {
  color: red;
}
</style>